import { useQuery } from "@tanstack/react-query";
import { sendAjaxRequest } from "@/ts/api/comunicacion";

export function usePuestosConCarga() {
	return useQuery({
		queryKey: ["getMaquinasConCarga"],
		queryFn: () => {
			return sendAjaxRequest<Puesto[]>("GET", "/api/v1/getMaquinasConCarga");
		}
	});
}
export interface Puesto {
	idPuesto: string;
	descripcion: string;
	cantidadHoras: number;
}